
import Gelerycards from "./Gelerycards";
import Foodbasicpaln from "../../Subscriptions/Foodbasicpaln";
import Foodpremiumplan from "../../Subscriptions/Foodpremiumplan";
import Bannernew from './Bannernew';


const FoodBanner = () => {

  return (
    <>

      {/* Other Components Below */}
      <Bannernew />

      <div style={{ marginTop: "20px" }}>
        <Gelerycards />
      </div>
      <div style={{ marginTop: "20px" }}>
        <Foodbasicpaln />
        <Foodpremiumplan />
      </div>
    </>
  );
};

export default FoodBanner;
